import API from "@/api";

export const apiGetCurrentBalance = () => {
  return API.get("api/subscriptions");
};
